export default "__VITE_ASSET__DDLS$AML__"